import formatCampaignInsightsContext from 'common/src/modules/campaigns/copilot/utils/contextFormatters/formatCampaignInsightsContext';
import formatCampaignLogicContext from 'common/src/modules/campaigns/copilot/utils/contextFormatters/formatCampaignLogicContext';
import formatConceptPlanContext from 'common/src/modules/campaigns/copilot/utils/contextFormatters/formatConceptPlanContext';
import formatMovieCompositionContext from 'common/src/modules/creativeTemplates/copilot/utils/contextFormatters/formatMovieCompositionContext';
import {ContextFormatter} from '../copilot.types';
import {CopilotContextKey} from './bootstrap.types';

const contextFormatters: Record<CopilotContextKey, ContextFormatter> = {
  [CopilotContextKey.CampaignWorkflow]: () => null,
  [CopilotContextKey.ConceptPlan]: formatConceptPlanContext,
  [CopilotContextKey.CampaignLogic]: formatCampaignLogicContext,
  [CopilotContextKey.CampaignInsights]: formatCampaignInsightsContext,
  [CopilotContextKey.MovieComposition]: formatMovieCompositionContext,
};

export default contextFormatters;
